
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/countries/[[...slug]]",
      function () {
        return require("private-next-pages/countries/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/countries/[[...slug]]"])
      });
    }
  